<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Cronogramas Físicos
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="cronogramasFisicos"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-cronograma-fisico
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-cronograma-fisico>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-excluir-cronograma-fisico
                                :pleito="pleito"
                                class="text-danger float-left mr-1"
                                :cronogramaFisico="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-excluir-cronograma-fisico>
                    </template>
                    <template slot="acao" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.nomeAcao }}
                        </p>
                    </template>
                    <template slot="ano" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.ano }}
                        </p>
                    </template>
                    <template slot="meses" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.meses }}
                        </p>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
    
<script>
import BtnInserirCronogramaFisico from './BtnInserirCronogramaFisico'
import BtnExcluirCronogramaFisico from './BtnExcluirCronogramaFisico'

export default {
    components: {
        BtnInserirCronogramaFisico,
        BtnExcluirCronogramaFisico
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoCronogramasFisicos: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            cronogramasFisicos: [],
            cronogramaFisico:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'nomeAcao',
                    label: 'Nome da Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'ano',
                    label: 'Ano',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'meses',
                    label: 'Meses',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterCronogramasFisicos(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.cronogramasFisicos = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.cronogramasFisicos = this.pleitoCronogramasFisicos
    }
}
</script>
